import React from 'react';
import { useLocation } from 'react-router-dom';
import ChannelInfo from '../components/ChannelInfo';
import ChannelPlaylist from '../components/ChannelPlaylist';
// videoDetail 컴포넌트에서 video.id가 아닌 channelid를 전달한다.

export default function VideoDetail() {
    const { state: {video} } = useLocation();
    const { title, channelId, channelTitle, description } = video.snippet;
    
    return (
        <section>
            <article>
                <iframe id='player' type='text/html' width='100%' height='640' 
                    src={`https://www.youtube.com/embed/${video.id}`}
                    frameBorder='0'
                    title={`YouTube video player for video ${video.id}`}/>
                <div>
                    <h2>{title}</h2>
                    <ChannelInfo id={channelId} name={channelTitle}/>
                    <pre>{description}</pre>
                    {/* // 여백이나 공백이 렌더링 되도록 해준다. title과 함께 이미지를 표시 */}
                </div>
            </article>
            <section>
                <ChannelPlaylist channelId={channelId}/>
                {/* <RelatedVideos id={video.id} /> */}
            </section>
            
        </section>
    )
    // iframe api를 사용하면 영상을 불러올 수 있다.

}

